/* Nối quiz với API chấm điểm.
 *
 * Quiz bê nguyên vẫn tự chấm trong trình duyệt để vẽ màn kết quả — không đụng vào. Việc của
 * file này là gửi câu trả lời sang máy chủ để LẤY MÃ PHIÊN. Mã đó mới là thứ mở khoá bản đọc
 * sau khi trả tiền: nó đi vào đơn qua thuộc tính giỏ, webhook bên API đọc rồi mới bật `full`.
 *
 * Không có mã phiên thì cả phần trả tiền vô nghĩa — khách trả xong không có gì để mở.
 *
 * MỘT LƯỢT GỬI cho mỗi lượt làm bài, và chỉ gửi lại khi lần trước HỎNG — tối đa ba lần. Gửi
 * lại không đẻ phiên rác: cùng `attempt_id` thì máy chủ trả lại đúng phiên đã lưu (lượt không
 * có mã — tracker không gắn được — thì không có lưới này).
 *
 * Gửi hỏng vẫn còn đường thứ hai: BỘ ĐÁP ÁN (`minespirit_bai`) được cất ngay lúc có kết quả,
 * trước mọi lượt gọi mạng, và hai đường gắn giỏ mang nó vào đơn dưới thuộc tính `_quiz_ans`.
 * Webhook bên API thấy đơn không có mã phiên thì tự dựng phiên từ đó. Ngày 15/09/2026 đơn
 * #1033 trả tiền mà không có phiên nào, và hai khách thật mất phiên cùng kiểu trước khi tới
 * checkout — submit hỏng, không ai biết.
 */

/* ── Một lượt mua, một đơn ───────────────────────────────────────────────────
   Ba nút mua của màn giá cùng gọi `window.__msMuaNgay`, còn các bản quiz cũ gọi
   thẳng một trong ba nút `buy`/`buy2`/`cdgo`. Cổng này đứng trước cả hai kiểu gọi:
   cú bấm đầu tiên được nhận, mọi cú sau bị chặn trong memory của trang. Không dùng
   storage vì khách phải có thể làm một lượt mua khác sau khi tải lại quiz.

   `quiz-sang-trang-ban.js` tự mở lại NÚT VỪA BẤM khi mạng lỗi. Vòng kiểm tra dưới
   đây nhìn đúng tín hiệu đó để mở lại toàn bộ ba nút và nói rõ cho khách thử lại;
   khi chuyển sang checkout thì trang rời đi và khóa sống tới lúc đó. */
(function () {
  var NUT_MUA = '#gd1-buy,#a7buy,#a7buy2,#a7stkbuy,#buy,#buy2,#cdgo';
  var muaDaKhoa = false;
  var nutDuocChapNhan = null;
  var henKiemTra = null;

  function timNutMua() {
    try { return document.querySelectorAll(NUT_MUA); } catch (e) { return []; }
  }

  function coDuongMua() {
    return typeof window.__msMuaNgay === 'function' ||
      typeof window.__msSangTrangBan === 'function';
  }

  function batKhoa(nut) {
    muaDaKhoa = true;
    nutDuocChapNhan = nut || null;
    var ds = timNutMua(), i, n;
    for (i = 0; i < ds.length; i++) {
      n = ds[i];
      if (!n.getAttribute('data-ms-mua-disabled-cu')) {
        n.setAttribute('data-ms-mua-disabled-cu', n.disabled ? '1' : '0');
      }
      if (!n.getAttribute('data-ms-mua-busy-cu')) {
        n.setAttribute('data-ms-mua-busy-cu', n.getAttribute('aria-busy') || '');
      }
      n.setAttribute('data-ms-mua-khoa', '1');
      n.disabled = true;
      n.setAttribute('aria-busy', 'true');
    }
  }

  function hienLoi(nut) {
    var o = document.getElementById('ms-mua-loi'), host, vi = false;
    try { vi = typeof state === 'object' && state && state.lang === 'vi'; } catch (e) {}
    if (!o) {
      o = document.createElement('p');
      o.id = 'ms-mua-loi';
      o.setAttribute('role', 'alert');
      o.setAttribute('aria-live', 'assertive');
      host = nut && nut.parentNode;
      if (!host) host = document.getElementById('scr') || document.body;
      if (host) host.appendChild(o);
    }
    if (o) {
      o.textContent = vi
        ? 'Không mở được trang thanh toán. Vui lòng thử lại.'
        : 'We could not open checkout. Please try again.';
    }
  }

  function moKhoa(baoLoi) {
    if (!muaDaKhoa) return;
    var nutLoi = nutDuocChapNhan;
    if (henKiemTra) { clearTimeout(henKiemTra); henKiemTra = null; }
    var ds = timNutMua(), i, n, cu, busy;
    for (i = 0; i < ds.length; i++) {
      n = ds[i];
      if (n.getAttribute('data-ms-mua-khoa') !== '1') continue;
      cu = n.getAttribute('data-ms-mua-disabled-cu');
      busy = n.getAttribute('data-ms-mua-busy-cu');
      n.disabled = cu === '1';
      if (busy) n.setAttribute('aria-busy', busy);
      else n.removeAttribute('aria-busy');
      n.removeAttribute('data-ms-mua-khoa');
      n.removeAttribute('data-ms-mua-disabled-cu');
      n.removeAttribute('data-ms-mua-busy-cu');
    }
    muaDaKhoa = false;
    nutDuocChapNhan = null;
    if (baoLoi) hienLoi(nutLoi);
  }

  function theoDoiNut(nut) {
    if (henKiemTra) clearTimeout(henKiemTra);
    if (!nut) return;
    function kiemTra() {
      if (!muaDaKhoa || nutDuocChapNhan !== nut) return;
      /* `muaNgay()` chỉ bỏ hai thuộc tính này trong nhánh thất bại. Nhánh thành công
         chuyển trang ngay và không bao giờ rơi vào đây. */
      if (!nut.disabled && nut.getAttribute('aria-busy') !== 'true') {
        moKhoa(true);
        return;
      }
      henKiemTra = setTimeout(kiemTra, 100);
    }
    henKiemTra = setTimeout(kiemTra, 100);
  }

  /* Phơi trạng thái cho tracker: `buy_clicked` phải đếm lượt được nhận, không đếm
     những cú bấm bị khóa. `__msMuaClickDuocChapNhan` sống hết event hiện tại để
     tracker (nạp sau file này) và wrapper bên dưới cùng nhận ra cú đầu tiên. */
  window.__msMuaDangChay = function () { return muaDaKhoa; };
  window.__msMuaClickDuocChapNhan = null;

  /* Bắt cả đường cũ gọi thẳng hàm riêng trong `quiz-sang-trang-ban.js`. Cú đầu tiên
     vẫn đi tiếp; chỉ các event sau mới bị dừng ở capture phase. */
  document.addEventListener('click', function (e) {
    try {
      var n = e.target && e.target.closest && e.target.closest(NUT_MUA);
      if (!n || !coDuongMua()) return;
      if (muaDaKhoa) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      window.__msMuaClickDuocChapNhan = n;
      batKhoa(n);
      theoDoiNut(n);
      setTimeout(function () { window.__msMuaClickDuocChapNhan = null; }, 0);
    } catch (er) {}
  }, true);

  /* Đường hiện tại gọi qua biến toàn cục, nên bọc lại để cú gọi trực tiếp cũng được
     khóa (ví dụ code tích hợp gọi hàm mà không phát event click). */
  var muaGoc = window.__msMuaNgay;
  if (typeof muaGoc === 'function') {
    window.__msMuaNgay = function (nut) {
      if (muaDaKhoa && window.__msMuaClickDuocChapNhan !== nut) return false;
      if (!muaDaKhoa) {
        batKhoa(nut);
        theoDoiNut(nut);
      }
      try {
        return muaGoc.apply(this, arguments);
      } catch (e) {
        moKhoa(true);
        return false;
      }
    };
  }

  /* Khi store chưa khai Storefront variant, nút rơi về trang bán cũ. Nó vẫn là một
     lượt mua nên phải dùng cùng cờ, dù không tạo giỏ trực tiếp trong tab này. */
  var sangGoc = window.__msSangTrangBan;
  if (typeof sangGoc === 'function') {
    window.__msSangTrangBan = function () {
      if (muaDaKhoa && !window.__msMuaClickDuocChapNhan) return false;
      if (!muaDaKhoa) batKhoa(null);
      try { return sangGoc.apply(this, arguments); }
      catch (e) { moKhoa(true); return false; }
    };
  }

  /* Bấm Back từ checkout: Safari và trình duyệt trong app Facebook khôi phục trang từ
     bộ nhớ đệm, JS giữ nguyên trạng thái lúc rời đi, nên khoá còn bật và cả ba nút mua
     bị vô hiệu cho tới khi khách tự tải lại. Trang hiện lại là lượt mua cũ đã kết thúc. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) moKhoa(false);
  });
})();

(function () {
  var goc = document.getElementById('phone');
  if (!goc) return;

  var API = (goc.getAttribute('data-goc-api') || '').replace(/\/+$/, '');
  if (!API) return;

  var KHOA_PHIEN = 'minespirit_phien';
  /* Hợp đồng với `quiz-sang-trang-ban.js` và `snippets/brand-pheu-gan-phien.liquid` (đọc
     khoá này) và `functions/_shared/quiz/webhook-routing.ts` bên API (đọc `_quiz_ans`).
     Nằm ở `sessionStorage`, KHÔNG phải `localStorage`: nó mang ngày sinh, mà tệp khách hay
     dùng máy chung — cùng luật với `minespirit_ban_do` ở `quiz-sang-trang-ban.js`. Đóng tab
     là mất, và vậy là đủ: nút mua chạy ngay trong tab làm quiz. */
  var KHOA_BAI = 'minespirit_bai';
  var KHOA_NGUON = 'minespirit_nguon';
  var KHOA_HANDOFF = 'minespirit_handoff';

  /* ── Handoff nonce ─────────────────────────────────────────────────────────
     Bắt bởi inline script trong `layout/quiz.liquid` từ `?h=<32 hex>` do
     app.minespirit.com đẻ ra khi khách đăng nhập bấm "Take the quiz". Chỉ đọc, không ghi
     — inline script đã cất sẵn. Kiểm định dạng phòng dữ liệu rác trong storage cũ. */
  function layHandoff() {
    try {
      var n = sessionStorage.getItem(KHOA_HANDOFF);
      if (n && /^[0-9a-f]{32}$/i.test(n)) return n.toLowerCase();
    } catch (e) {}
    return null;
  }

  /* ── Nguồn khách ────────────────────────────────────────────────────────────
     Hợp đồng: khoá lạ → 400 và HỎNG CẢ LƯỢT GỬI. Nên lọc trắng đúng chín khoá,
     không forward bừa mọi tham số trên địa chỉ. Cắt 512 ký tự vì máy chủ chặn ở đó
     (`click_id_type` chỉ 32). Ghi lại phòng khách tải lại trang trước khi nộp. */
  var KHOA_UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var KIEU_CLICK = { fbclid: 'fbclid', ttclid: 'ttclid', gclid: 'gclid', msclkid: 'msclkid' };

  function cat(v, n) {
    if (v == null) return null;
    v = String(v).trim();
    return v ? v.slice(0, n || 512) : null;
  }

  function batNguon() {
    try {
      var da = localStorage.getItem(KHOA_NGUON);
      if (da) return JSON.parse(da);
    } catch (e) { /* Cửa sổ riêng tư — cứ đọc lại từ địa chỉ. */ }

    var p;
    try { p = new URLSearchParams(location.search); } catch (e) { return null; }
    var t = {}, co = false;
    for (var i = 0; i < KHOA_UTM.length; i++) {
      var v = cat(p.get(KHOA_UTM[i]));
      if (v) { t[KHOA_UTM[i]] = v; co = true; }
    }
    for (var k in KIEU_CLICK) {
      if (!KIEU_CLICK.hasOwnProperty(k)) continue;
      var c = cat(p.get(k));
      if (c) { t.click_id = c; t.click_id_type = cat(KIEU_CLICK[k], 32); co = true; break; }
    }
    var r = cat(document.referrer);
    if (r) { t.landing_referrer = r; co = true; }
    if (!co) return null;
    try { localStorage.setItem(KHOA_NGUON, JSON.stringify(t)); } catch (e) {}
    return t;
  }

  /* ── Câu trả lời ────────────────────────────────────────────────────────────
     Quiz lưu lựa chọn nhiều đáp án bằng CHỈ SỐ, còn máy chủ nhận khoá bền. Không tra
     bảng thì gửi số sang là sai người sai đáp án mà không báo lỗi. Bảng tra lấy từ
     `/api/quiz/schema` — đó là lý do phải gọi nó dù câu hỏi đang khai cứng trong quiz. */
  var bangMulti = null;

  /* Phiên bản bộ đề. v4 = 21 câu chấm điểm xếp lại thứ tự, cộng cột `positive` (11/21 câu
     `true`, chấm bằng ramp đảo), cộng màn 30 (`fear`) vào DB thành câu multi thứ tư.

     Máy chủ phục vụ NHIỀU bộ cùng lúc (`QUIZ_SCHEMA_VERSIONS_ACCEPTED`), nên JS cũ còn kẹt
     trong cache CDN vẫn gửi được bài bằng bộ cũ của nó cho tới khi bộ đó bị gỡ khỏi danh sách.
     Lúc bị gỡ thì máy chủ trả lời khác nhau ở hai đầu:
       `/api/quiz/schema?v=` thiếu  -> 400
       `/api/quiz/schema?v=` lệch   -> 410 kèm `live`
       `/api/quiz/submit` lệch      -> 409 kèm `live`
     Nuốt lỗi là khách làm xong 21 câu rồi mất trắng bài mà không hiểu vì sao — phải nói
     thẳng để họ tải lại trang. */
  var BO_DE = 'v4';
  // Hợp đồng với `quiz-do-duong.js`: file kia chỉ đọc, không ghi.
  window.__msBoDe = BO_DE;

  function baoTaiLai() {
    try {
      var vi = (typeof isVI === 'function') ? isVI() : false;
      alert(vi
        ? 'Bản quiz trên máy bạn đã cũ. Vui lòng tải lại trang để gửi bài.'
        : 'This page is out of date. Please reload to send your answers.');
    } catch (e) {}
  }

  /* Snapshot và response `/api/quiz/schema` mang câu multi dưới CÙNG một hình dạng
     (`multi[].options[].ord`, `.stable_key`), nên một hàm dựng bảng cho cả hai nguồn. */
  function dungBangMulti(multi) {
    var b = {};
    (multi || []).forEach(function (q) {
      var m = {};
      (q.options || []).forEach(function (o) { m[o.ord] = o.stable_key; });
      b[q.id] = m;
    });
    return b;
  }

  function napSchema() {
    return fetch(API + '/api/quiz/schema?v=' + encodeURIComponent(BO_DE), { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.status === 410) { baoTaiLai(); throw hong('stale', 's410', true); }
        return r.text();
      })
      .then(function (chu) {
        var d = JSON.parse(chu);
        bangMulti = dungBangMulti(d.multi);
        return bangMulti;
      });
  }

  /* Bảng tra có mặt NGAY LÚC NẠP, không đợi mạng. `assets/quiz-bo-de.js` là snapshot sinh tự
     động của chính bộ đề này và là nguồn hiển thị của quiz; lấy bảng tra từ đó thì
     `dungCauTraLoi()` không còn trả `null` chỉ vì mạng hỏng. Lệch phiên bản thì coi như không
     có: gửi khoá bền của một bộ đề khác còn tệ hơn bỏ cả lượt gửi. */
  (function () {
    var snap = window.__msBoDeSnapshot;
    if (!snap || snap.version !== BO_DE) return;
    bangMulti = dungBangMulti(snap.multi);

    /* `bangMulti` khác `null` làm đường gửi bên dưới bỏ qua `napSchema()`, mà đó là chỗ DUY
       NHẤT bắt 410. Gọi ngay tại đây để giữ cổng ấy sống. Hỏng vì mạng thì im lặng — bảng tra
       từ snapshot vẫn đủ dùng; còn nhánh 410 ở trên đã báo cho khách TRƯỚC khi ném, nên nuốt
       lời hứa ở đây không giấu mất lời cảnh báo nào. */
    napSchema()['catch'](function () {});
  })();

  function dungCauTraLoi() {
    var q = (typeof state === 'object' && state && state.q7) ? state.q7 : null;
    if (!q) return null;
    var ra = {};
    for (var k in q) {
      if (!q.hasOwnProperty(k)) continue;
      var v = q[k];
      if (Array.isArray(v)) {
        var bang = bangMulti && bangMulti[k];
        if (!bang) return null;            /* Thiếu bảng tra thì đừng đoán — bỏ cả lượt gửi. */
        var ds = [];
        for (var i = 0; i < v.length; i++) {
          var kb = bang[v[i]];
          if (kb) ds.push(kb);
        }
        ra[k] = ds;
      } else if (typeof v === 'number') {
        ra[k] = v;
      }
    }
    return ra;
  }

  /* Từ bản sửa giai đoạn 1: màn giờ sinh và nơi sinh bị BỎ HẲN, màn ngày sinh có nút Skip.
     Hệ quả với hợp đồng gửi bài:
       `city` bỏ hẳn — không màn nào nhận nó nữa, gửi lên là gửi một giá trị bịa
              (`?demo=` vẫn gán `state.bplace`, và đó chính là cách nó lọt vào thật).
       `date` có thể VẮNG — khách bấm Skip. Trả `null` như bản cũ là `gui()` ném
              "thieu du lieu" và cả lượt không bao giờ có `session_id`: khách trả tiền
              xong không mở được bản đọc. Trả object rỗng để bài vẫn đi.
     `time` giữ nhánh vì `?demo=` còn đặt `state.btime`; khách thật không bao giờ có. */
  function dungNgaySinh() {
    var b = (typeof state === 'object' && state) ? state : {};
    var d = b.bdate;
    var hai = function (n) { return (n < 10 ? '0' : '') + n; };
    var ra = {};
    if (d && d.y) ra.date = d.y + '-' + hai(d.m) + '-' + hai(d.d);
    if (b.btime) ra.time = b.btime;
    /* Tên đi trong `birth.name` (máy chủ đọc đúng chỗ đó: `parseBirth`). Thiếu nó thì bản
       đọc ghi "For: Friend" và các số thần số học theo tên tính trên chữ "Friend" — 11/12
       phiên thật 27–30/09 bị như vậy. Chỉ gửi khi khách TỰ gõ (`a5DaGoTen`): `chotTen()`
       ghi "Friend" vào `state.name` khi trống, gửi chữ đó là lại tính số trên "Friend".
       Gửi tên đầy đủ như bản gốc `minespirit-quiz` — thần số học cần mọi chữ trong tên.
       Cắt 80 ký tự (`NAME_MAX` bên máy chủ): tên này cũng vào `_quiz_ans`, và bộ đáp án quá
       4000 ký tự thì webhook bỏ CẢ bộ — mất đường dựng phiên chỉ vì một cái tên dài. */
    var ten = b.a5DaGoTen ? String(b.fullName || b.name || '').trim().slice(0, 80) : '';
    if (ten) ra.name = ten;
    return ra;
  }

  /* Bộ đáp án đi theo đơn: `{"v":"v3.1","t":"<lượt>","a":{"Q1":2,…,"M-A":[0,3]},"d":"…","n":"…"}`.
     Giữ CHỈ SỐ như quiz lưu, không đổi sang khoá bền — máy chủ nhận cả hai, và làm vậy thì
     dựng được bộ đáp án mà không cần `/api/quiz/schema`, tức là không cần mạng. Ngày sinh và
     tên có thì kèm, bỏ qua thì thôi: đúng những gì `gui()` gửi, không hơn. */
  function dungBai(luot) {
    var q = (typeof state === 'object' && state && state.q7) ? state.q7 : null;
    if (!q) return '';
    var a = {}, co = false;
    for (var k in q) {
      if (!q.hasOwnProperty(k)) continue;
      var v = q[k];
      var laSo = function (x) { return typeof x === 'number'; };
      if (laSo(v) || (Array.isArray(v) && v.every(laSo))) { a[k] = v; co = true; }
    }
    if (!co) return '';
    var bai = { v: BO_DE, a: a };
    if (luot) bai.t = luot;
    var sinh = dungNgaySinh();
    if (sinh.date) bai.d = sinh.date;
    /* Tên khách tự gõ, cùng giá trị submit gửi trong `birth.name`. Webhook dựng phiên từ bộ
       này khi submit không về; thiếu tên thì phiên đó ghi "For: Friend" (đơn #1069). */
    if (sinh.name) bai.n = sinh.name;
    return JSON.stringify(bai);
  }

  /* ── Banner preview email đích ─────────────────────────────────────────────
     Gọi `/api/quiz/handoff/preview?h=<nonce>` — KHÔNG consume nonce, chỉ trả email đã
     che (`a***@g***.tld`). 200 → hiện banner để khách xác nhận đúng tài khoản trước khi
     nộp; 404/lỗi → im lặng, banner ẩn, quiz vẫn chạy anon fallback. Đây là chốt phòng
     vector attacker chèn nonce của mình vào URL nạn nhân: khách nhìn email lạ có thể dừng. */
  function hienBannerHandoff() {
    var hn = layHandoff();
    if (!hn) return;
    fetch(API + '/api/quiz/handoff/preview?h=' + encodeURIComponent(hn), {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { if (!r.ok) throw new Error('no preview'); return r.json(); })
      .then(function (d) {
        if (!d || !d.email_masked) return;
        var el = document.getElementById('handoff-banner');
        var em = document.getElementById('handoff-email');
        if (!el || !em) return;
        em.textContent = d.email_masked;
        el.hidden = false;
      })
      ['catch'](function () { /* Nonce hết hạn hoặc mạng lỗi — im lặng, quiz vẫn chạy. */ });
  }

  hienBannerHandoff();

  /* ── Cổng chặn gửi trùng ────────────────────────────────────────────────────
     Chặn theo LƯỢT LÀM BÀI, không chặn theo đời máy của khách.

     Bản trước gác bằng `if (localStorage.getItem(KHOA_PHIEN)) return`. `localStorage` sống
     qua việc đóng tab, đóng trình duyệt, và dùng chung mọi tab cùng origin — nên cổng đó
     đúng một lần trong đời máy khách: từ lượt thứ hai trở đi `gui()` thoát ngay dòng
     đầu, không row `quiz_sessions` nào sinh ra, không lỗi nào báo. Tệ hơn, đơn đặt sau đó
     vẫn mang `session_id` của lượt ĐẦU vì đường gắn giỏ đọc lại đúng khoá cũ — khách trả
     tiền rồi nhận luận giải của lần khác (issue #95).

     `dangGui` một mình cũng không đủ: nó ở lại `true` sau khi gửi xong, mà "Start over" xảy
     ra trong CÙNG một lần tải trang.

     Nên gác bằng `minespirit_luot` — mã lượt `quiz-do-duong.js` mint mới mỗi lần tải trang
     và mỗi lần Start over. Hai cờ dưới đây đều sống trong memory: KHÔNG khoá storage nào
     được phép chặn lượt sau. */
  var DANG_LUOT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  var KHOA_PHIEN_LUOT = 'minespirit_phien_luot';

  /* Kiểm định dạng vì khoá lạ làm máy chủ trả 400 và HỎNG CẢ LƯỢT GỬI, mà storage cũ thì có
     thể còn rác.

     Tracker không gắn được — theme editor, hoặc `quiz-inner-weather.js` bị thay trọn gói làm
     `goto`/`SCREENS` đổi — thì hàm này trả '' cho MỌI lượt, và hệ quả phải nói thẳng: trong
     lần tải trang đó Start over sẽ KHÔNG gửi. Vẫn đúng triệu chứng #95, chỉ hẹp lại từ "một
     lần trong đời máy khách" xuống "một lần mỗi lần tải trang" (tải lại trang thì gửi được).

     Chấp nhận đánh đổi vì ở chế độ đó không còn tín hiệu nào phân biệt "màn kết quả dựng lại
     lần hai" với "lượt làm bài mới", mà gửi trùng thì đẻ phiên rác và ăn hạn mức 10 lần/phút
     /IP. Đáng chú ý: điều kiện kích hoạt chính là kịch bản `quiz-do-duong.js` tự dặn là lo
     nhất — quiz bị thay trọn gói. */
  function layLuot() {
    try {
      var l = sessionStorage.getItem('minespirit_luot');
      if (l && DANG_LUOT.test(l)) return l.toLowerCase();
    } catch (e) {}
    return '';
  }

  var luotDangGui = null;              /* lượt đang bay */
  var luotDaXong = null;               /* lượt đã gửi xong (hoặc đã bỏ cuộc) trong lần tải trang này */

  /* ── Thử lại và báo kết quả ─────────────────────────────────────────────────
     Ngày 15/09/2026 hai khách thật mất phiên mà không một dòng nào ở phía trình duyệt kể
     lại chuyện gì: `catch` nuốt sạch. Giờ mỗi lần hỏng bắn `submit_failed` với `screen` là
     BƯỚC hỏng (schema · answers · network · http · stale) và `question_id` là
     chi tiết (mã HTTP `s503`, tên lỗi mạng…); gửi được thì `submit_ok` kèm lần thứ mấy.

     Chỉ thử lại lỗi CÓ THỂ tự hết: mạng, 429, 5xx.
     409/410 và 400 lần nào cũng ra y hệt, thử lại chỉ ăn hạn mức 10 lần/phút/IP. */
  var LAN_THU_TOI_DA = 3;

  function hong(buoc, chiTiet, chiMot) {
    var e = new Error(buoc);
    e.buoc = buoc; e.chiTiet = chiTiet; e.chiMot = !!chiMot;
    return e;
  }

  /* Máy chủ chối CẢ LÔ event nếu một trường sai khuôn — lọc ký tự trước khi gửi. */
  function baoSuKien(ev, buoc, chiTiet) {
    var sach = function (x, khuon) {
      x = String(x || '').replace(khuon, '_').slice(0, 40);
      return x || null;
    };
    try {
      if (typeof window.__msSuKien === 'function') {
        window.__msSuKien({ event: ev, screen: sach(buoc, /[^A-Za-z0-9_-]+/g),
                            question_id: sach(chiTiet, /[^A-Za-z0-9_.-]+/g) });
      }
    } catch (e) {}
  }

  function gui() {
    var luot = layLuot();
    if (luotDangGui !== null) return;
    if (luotDaXong === luot) return;   /* `layLuot()` luôn trả string, `null` không khớp. */

    /* Tải lại cùng tab ở màn 36/37 thì lượt ĐI TIẾP (`window.__msTiepLuot`, xem
       `quiz-do-duong.js`), và màn 36 dựng lại gọi tới đây lần nữa trong một lần tải trang
       MỚI — hai cờ memory ở trên đã trắng. Lượt này đã có mã phiên thì đó là lần gửi thứ
       hai của cùng một bài: bỏ qua. Chặn theo đúng mã lượt, nên lượt sau không bao giờ bị
       chặn; mã lượt rỗng (tracker không gắn) thì không chặn gì. */
    try {
      if (luot && localStorage.getItem(KHOA_PHIEN_LUOT) === luot &&
          DANG_LUOT.test(localStorage.getItem(KHOA_PHIEN) || '')) {
        luotDaXong = luot;
        return;
      }
    } catch (e) {}

    /* Cất bộ đáp án TRƯỚC mọi thứ có thể hỏng. Nó là
       đường mở khoá khi submit không về; ghi đè mỗi lượt nên không bao giờ mang bài lượt cũ. */
    try {
      var bai = dungBai(luot);
      if (bai) sessionStorage.setItem(KHOA_BAI, bai);
      else sessionStorage.removeItem(KHOA_BAI);
    } catch (e) {}

    luotDangGui = luot;

    /* Mã phiên đang lưu thuộc về lượt khác thì DỌN NGAY, đừng đợi lượt này gửi xong. Gửi có
       thể hỏng (mạng, hạn mức) — lúc đó thà đơn không mang mã còn hơn mang mã
       của lượt trước: thiếu mã thì còn mở bản đọc bằng đường khác, sai mã thì khách nhận
       nhầm luận giải mà không ai biết. `minespirit_phien_luot` chỉ để nhận ra mã cũ, KHÔNG
       bao giờ được dùng làm cổng chặn.

       Dọn CẢ `sessionStorage`: hai đường gắn giỏ (`quiz-sang-trang-ban.js`,
       `snippets/brand-pheu-gan-phien.liquid`) đều đọc `sessionStorage || localStorage`, tức
       sessionStorage THẮNG. Hôm nay không file nào ghi khoá đó vào sessionStorage, nên dọn
       một nơi là đủ — nhưng đủ nhờ một invariant nằm ở FILE KHÁC, mà đúng loại phụ thuộc đó
       vừa đẻ ra #95. Một dòng, khỏi phải nhớ. */
    try {
      if (localStorage.getItem(KHOA_PHIEN_LUOT) !== luot) {
        localStorage.removeItem(KHOA_PHIEN);
        localStorage.removeItem(KHOA_PHIEN_LUOT);
        try { sessionStorage.removeItem(KHOA_PHIEN); } catch (e) {}
      }
    } catch (e) {}

    /* Phơi lượt gửi đang bay cho nút mua. Đơn #1022 (08/09): mã cấp đơn có, mã dòng hàng
       không — submit trả `session_id` đúng giữa hai lần đọc storage của `muaNgay()`. Đơn #1024
       cùng ngày rỗng cả hai vì khách bấm mua trước khi submit xong. Nút mua đợi promise này
       rồi mới đọc mã — xem `doiPhien()` trong `quiz-sang-trang-ban.js`. Promise này kéo dài
       qua mọi lần thử và không bao giờ reject. */

    /* Chốt câu trả lời MỘT lần cho cả lượt gửi: Start over giữa hai lần thử đổi `state`,
       đọc lại là gửi bài lượt mới dưới mã lượt cũ. */
    var birth = dungNgaySinh();
    var answers = null;

    function motLan() {
      var buoc = 'schema';
      return (bangMulti ? Promise.resolve(bangMulti) : napSchema())
        .then(function () {
          buoc = 'answers';
          if (!answers) answers = dungCauTraLoi();
          if (!answers) throw hong('answers', '', true);
          var than = { answers: answers, birth: birth, question_set_version: BO_DE };
          var em = (typeof state === 'object' && state && state.email) ? cat(state.email) : null;
          if (em) than.email = em;
          var hn = layHandoff();
          if (hn) than.handoff_nonce = hn;
          /* Mã lượt do `quiz-do-duong.js` sinh. `minespirit_luot` là HỢP ĐỒNG GIỮA HAI FILE:
             thiếu nó ở đây thì `quiz_attempts.session_id` mãi rỗng và cả đường nối "ai đã
             mua" chết — không lỗi nào báo. Dùng đúng giá trị đã chốt ở cổng chặn: Start over
             giữa lúc đang bay sẽ đổi khoá trong sessionStorage, đọc lại là gắn nhầm lượt. */
          if (luot) than.attempt_id = luot;
          buoc = 'network';
          return fetch(API + '/api/quiz/submit', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(than)
          });
        })
        .then(function (r) {
          buoc = 'http';
          if (r.status === 409) { baoTaiLai(); throw hong('stale', 's409', true); }
          if (!r.ok) throw hong('http', 's' + r.status, r.status === 400);
          return r.text();
        })
        .then(function (chu) {
          var d = JSON.parse(chu);
          if (!d || !d.session_id) throw hong('http', 'no_session_id');
          return d.session_id;
        })
        ['catch'](function (e) {
          if (e && e.buoc) throw e;
          throw hong(buoc, (e && (e.name === 'SyntaxError' ? 'parse' : e.message)) || 'unknown');
        });
    }

    function thu(lan) {
      return motLan().then(function (maPhien) {
        try {
          localStorage.setItem(KHOA_PHIEN, maPhien);
          localStorage.setItem(KHOA_PHIEN_LUOT, luot);
        } catch (e) {}
        try { sessionStorage.removeItem(KHOA_HANDOFF); } catch (e) {}
        luotDaXong = luot;
        baoSuKien('submit_ok', 'done', 'try' + lan);
      }, function (e) {
        baoSuKien('submit_failed', e.buoc, e.chiTiet);
        /* Lỗi lần nào cũng ra y hệt: đánh dấu xong để nút mua không gọi lại vô ích. Đơn vẫn
           mở khoá được bằng bộ đáp án đi theo đơn. */
        if (e.chiMot) { luotDaXong = luot; return; }
        if (lan >= LAN_THU_TOI_DA || layLuot() !== luot) return;
        return new Promise(function (xong) { setTimeout(xong, 1500 * lan); })
          .then(function () { return thu(lan + 1); });
      });
    }

    window.__msPhienDangBay = thu(1)
      ['catch'](function () {})
      .then(function () {
        luotDangGui = null;
        window.__msPhienDangBay = null;
        /* Hỏng hết vẫn không chặn gì cả. Khách vẫn xem được kết quả và vẫn mua được — đơn
           mang bộ đáp án, webhook tự dựng phiên. Thà bán được mà thiếu mã còn hơn chặn cửa
           mua vì một lượt gọi mạng hỏng. */
      });
  }

  /* Nút mua gọi khi chưa có mã phiên và không có lượt nào đang bay — tức mọi lần thử trước
     đã hỏng. Trả promise đang bay (hoặc `null`) để nút mua đợi có giới hạn. */
  window.__msGuiLai = function () {
    try { gui(); } catch (e) {}
    return window.__msPhienDangBay || null;
  };

  /* Gửi khi khách vừa chấm xong, tức lúc màn kết quả dựng lần đầu.

     PHẢI NGHE CẢ HAI MÀN KẾT QUẢ, không chỉ `docReport`.
     Đo thứ tự màn trên live 31/08: docMap = 40, docReport = 41, sale4 = 42. Khách xem xong
     bản đồ ở màn 40 rồi bấm nút mở khoá là nhảy THẲNG tới 42 — màn 41 không bao giờ dựng.
     Bản trước chỉ bọc `docReport` nên `gui()` không chạy lần nào: không có `session_id`,
     `ganPhienVaoGio()` thoát ngay ở dòng đầu, đơn về rỗng thuộc tính. Đúng triệu chứng đo
     được ở đơn #1016 và #1017 — mua từ trong quiz mà vẫn không có `quiz_session`.
     `gui()` tự chặn gọi trùng theo mã lượt, nên nghe thừa là vô hại. */
  /* `hub` là màn kết quả MỚI của bản sửa giai đoạn 1 — nó thay cả hub cũ, docMap, docReport
     và sale4, và từ 08/09/2026 nó là màn kết quả DUY NHẤT còn trong `SCREENS`
     (`quiz-giai-doan-1.js`). Bỏ nó khỏi danh sách là `gui()` không chạy lần nào: không có
     `session_id`, đơn về rỗng thuộc tính — đúng triệu chứng đơn #1016/#1017.
     Giữ hai tên cũ: chúng vẫn còn trong `RENDER`, và bọc thừa thì `gui()` tự chặn trùng. */
  var MAN_KET_QUA = ['hub', 'docReport', 'docMap'];

  for (var mi = 0; mi < MAN_KET_QUA.length; mi++) {
    (function (ten) {
      if (typeof RENDER !== 'object' || typeof RENDER[ten] !== 'function') return;
      var goc_render = RENDER[ten];
      RENDER[ten] = function () {
        try { gui(); } catch (e) {}
        return goc_render.apply(this, arguments);
      };
    })(MAN_KET_QUA[mi]);
  }

  /* Vào thẳng bằng `?screen=`: màn đã dựng trước khi file này chạy, bản bọc ở trên không ăn. */
  try {
    if (typeof cur === 'number' && SCREENS[cur] &&
        MAN_KET_QUA.indexOf(SCREENS[cur].t) !== -1) gui();
  } catch (e) {}
})();
